import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FinishProComponent } from './finish-pro.component';
import { IntroComponent } from './pages/intro/intro.component';
import { SignatureStatusComponent } from './pages/signature-status/signature-status.component';
import { ThanksComponent } from './pages/thanks/thanks.component';
import { OperationGuardService } from './services/operation-guard.service';
import { WebSocketSignerProComponent } from './components/signature/signature-pad/webSocketsigner.component';
import { ErrorComponent } from './pages/error/error.component';
import { DocumentViewerComponent } from './pages/document-viewer/document-viewer.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { OperationNOTEComponent } from './pages/operation-NOTE/operation-NOTE.component';
import { SimpleSignComponent } from './pages/simple-sign/simple-sign.component';
import { RedirectMfsComponent } from './components/signature/ivsignpro/redirect-mfs/redirect-mfs.component';

const routes: Routes = [
  {
    path: '',
    component: FinishProComponent,
    children: [
      { path: 'intro', component: IntroComponent },
      { path: 'custom-checkbox', component: TermsAndConditionsComponent },
      { path: 'operation-NOTE', component: OperationNOTEComponent },
      { path: 'document/:documentId', component: DocumentViewerComponent },
      { path: 'signature-status', component: SignatureStatusComponent },
      { path: 'thanks', component: ThanksComponent },
      { path: 'error', component: ErrorComponent },
      { path: 'simple', component: SimpleSignComponent}
    ],
    canActivate: [OperationGuardService]
  },
  {
    path: 'document/:id/webSocketProOperation',
    component: WebSocketSignerProComponent
  },
  {
    path: 'document/:id/redirectMFS',
    component: RedirectMfsComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinishProRoutingModule { }
